export default el => {
	if (el instanceof HTMLElement) {
		const playBtn = el.querySelector("[data-play-btn]");

		if (playBtn) {
			const videoContainer = el.querySelector("[data-video=container]");
			const video = videoContainer.querySelector("video");

			playBtn.addEventListener("click", () => {
				videoContainer?.classList.remove("videoFrameHidden")
				video?.play();
			});
		}
	}
}
